import PropTypes from "prop-types";
import SectionRenderer from "../../../components/SectionRenderer";
import { formatCurrency } from "../../../utils/proposalHelpers";

export default function CanvasPreviewPane({
	activeSectionIndex,
	setActiveSectionIndex,
	sections,
	updateSection,
	selectedItems,
	previewCompany,
}) {
	return (
		<div className="min-h-[800px] bg-[#0B0F19] relative">
			{/* Background click handler */}
			<button
				type="button"
				className="absolute inset-0 w-full h-full cursor-default border-none focus:outline-none bg-transparent"
				onClick={() => setActiveSectionIndex(null)}
				aria-label="Desmarcar seção ativa"
			/>

			<div className="relative z-10">
				<div className="bg-gradient-to-br from-[#0F1629] to-[#0B0F19] p-12 border-b border-white/5">
					<p className="text-cyan-400 text-sm font-bold uppercase tracking-wider mb-2">
						Proposta Comercial
					</p>
					<h3 className="text-4xl font-bold text-white mb-2">
						{previewCompany.name}
					</h3>
					{previewCompany.tagline && (
						<p className="text-lg text-slate-400">{previewCompany.tagline}</p>
					)}
				</div>

				{sections
					.filter(
						(s) =>
							s.type === "company_intro" ||
							s.title ||
							s.content ||
							(s.cards && s.cards.length > 0) ||
							(s.images && s.images.length > 0),
					)
					.map((section, idx) => (
						<button
							key={section.id || `preview-section-${idx}`}
							type="button"
							onClick={(e) => {
								e.stopPropagation();
								setActiveSectionIndex(idx);
							}}
							className={`w-full text-left transition-all duration-200 border-2 focus:outline-none focus:ring-1 focus:ring-cyan-500/50 ${
								activeSectionIndex === idx
									? "border-cyan-500 z-20 scale-[1.01] shadow-2xl shadow-cyan-900/20"
									: "border-transparent hover:border-white/10"
							}`}
						>
							<SectionRenderer
								section={section}
								index={idx}
								company={previewCompany}
								compact={false}
								editable={true}
								onUpdate={(field, value) => updateSection(idx, field, value)}
							/>
						</button>
					))}

				{sections.length === 0 && (
					<div className="py-24 text-center border-2 border-dashed border-slate-800 m-12 rounded-xl">
						<p className="text-slate-500">
							Adicione seções para ver a proposta
						</p>
					</div>
				)}

				{selectedItems.length > 0 && (
					<div className="p-12 border-t border-white/5 bg-[#0F121C]">
						<h4 className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-6">
							Resumo de Investimento
						</h4>
						<div className="space-y-4 max-w-2xl">
							{selectedItems.map((item, i) => (
								<div
									key={item.id || `preview-item-${i}`}
									className="flex items-center justify-between p-4 rounded-xl bg-slate-800/30 border border-white/5"
								>
									<div className="flex items-center gap-4">
										<div
											className={`w-10 h-10 rounded-lg flex items-center justify-center text-xs font-bold ${
												item.item_type === "plan"
													? "bg-cyan-600/20 text-cyan-400"
													: "bg-purple-600/20 text-purple-400"
											}`}
										>
											{item.item_type === "plan" ? "P" : "M"}
										</div>
										<div>
											<span className="block text-sm text-white font-medium">
												{item.name}
											</span>
											{item.subtitle && (
												<span className="text-xs text-slate-500">
													{item.subtitle}
												</span>
											)}
										</div>
									</div>
									<div className="text-right">
										<span className="block text-sm font-bold text-green-400">
											R${" "}
											{formatCurrency(parseFloat(item.value) * item.quantity)}
										</span>
										{item.quantity > 1 && (
											<span className="text-[10px] text-slate-500">
												{item.quantity}x R$ {item.value}
											</span>
										)}
									</div>
								</div>
							))}
						</div>
					</div>
				)}

				<div className="p-8 text-center border-t border-white/5">
					<p className="text-xs text-slate-600">
						Documento Confidencial - {new Date().getFullYear()}
					</p>
				</div>
			</div>
		</div>
	);
}

CanvasPreviewPane.propTypes = {
	activeSectionIndex: PropTypes.number,
	setActiveSectionIndex: PropTypes.func.isRequired,
	sections: PropTypes.array.isRequired,
	updateSection: PropTypes.func.isRequired,
	selectedItems: PropTypes.array.isRequired,
	previewCompany: PropTypes.object.isRequired,
};
